import * as React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useMediaQuery, useTheme } from "@mui/material";

/**
 * Shows a rendered email (subject and HTML body) in a dialog. The HTML is produced by the server and
 * displayed in a sandboxed iframe, so nothing in it can run scripts or reach the page around it.
 */
export default function EmailPreviewDialog({ open, onClose, subject, html, note }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" fullScreen={fullScreen}>
      <DialogTitle>Preview</DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="text.secondary">
          Subject
        </Typography>
        <Typography sx={{ mb: 1.5, fontWeight: 600 }}>{subject}</Typography>
        {note ? (
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
            {note}
          </Typography>
        ) : null}
        <Box
          component="iframe"
          title="Email preview"
          sandbox=""
          srcDoc={html ?? ""}
          sx={{ width: "100%", height: 480, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#f3f4f6" }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
